import './AuthMethodLayout.less';
import type { ReactNode, PropsWithChildren } from 'react';
interface AuthMethodLayoutProps {
  graphic?: ReactNode;
}
const AuthMethodLayout = ({ children, graphic }: PropsWithChildren<AuthMethodLayoutProps>) => {
  return (
    <div className="auth-method">
      <div className="auth-method-card">
        <div className="auth-method-left-panel">
          {graphic}
        </div>
        <div className="auth-method-right-panel">
          {children}
        </div>
      </div>
    </div>
  );
};
export default AuthMethodLayout;
